<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">ایجاد نمونه کار</h6>
          <form class="border" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">عنوان
                    <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="عنوان را وارد کنید!" name="title" v-model="form.title" >
                <span class="help text-danger" v-if="form.errors.has('title')" v-text="form.errors.get('title')"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">توضیحات
                    <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="توضیحات را وارد کنید!" name="description" v-model="form.description">
                <span class="help text-danger" v-if="form.errors.has('description')" v-text="form.errors.get('description')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                     <label>تاریخ پایان مرخصی
                        <span class="text-danger">*</span>
                     </label>
                     <date-picker v-model="form.year" color="#007bff" label="سال" type="year"></date-picker>
                  </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">کاور
                    <span class="text-danger">*</span>
                </label>
                <input type="file" class="form-control" ref="cover" placeholder="عکس کاور راانتخاب کنید!" required>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">گالری
                    <span class="text-danger">*</span>
                </label>
                <input type="file" class="form-control" ref="gallery" multiple="multiple" required placeholder="عکس های گالری راانتخاب کنید!">
              </div>
              <div class="progress m-b-20" v-if="progress > 0 && progress < 100">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
                </div>
              </div>
            </div>
            <div class="btn-group d-flex justify-content-center">
              <button class="btn btn-success col-md-2 my-3 btn-pulse" type="submit" :disabled="form.errors.any()">ذخیره</button>
                <router-link :to="{name: 'portfolio.index'}" class="btn btn-dark col-md-2 my-3" type="button"><span
                  class="text-white">بازگشت</span></router-link>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'PortfolioCreate',
  data () {
    return {
      progress: 0,
      cover: null,
      gallery: [],
      form: new this.$form({
        title: '',
        description: '',
        year: null
      })
    }
  },
  beforeCreate () {
    if (!this.$store.getters.access(this.$route.name)) {
      this.$router.push({ name: '403' })
    }
  },
  watch: {
    progress: function (val) {
      if (val === 100) {
        this.gallery = true
        val = 0
        // eslint-disable-next-line no-undef
        swal(
          'تبریک!',
          'نمونه کار جدید با موفقیت ایجاد شد!',
          'success'
          , {
            button: 'باشه'
          })
        this.$router.push({ name: 'portfolio.index' })
      }
    }
  },
  methods: {
    onSubmit () {
      this.$send.submit('post', '/api/portfolio', this.form.data())
        .then(response => {
          const formData = new FormData()
          const file = this.$refs.cover.files[0]
          formData.append('cover', file)
          this.$send.submit('post', 'api/portfolio/' + response.id + '/upload/cover', formData)
            .then(response => {
              this.cover = true
            })

          this.count = this.$refs.gallery.files.length
          for (var i = 0; i < this.count; i++) {
            const formData = new FormData()
            const file = this.$refs.gallery.files[i]
            formData.append('gallery', file)
            this.$send.submit('post', 'api/portfolio/' + response.id + '/upload/gallery', formData)
              .then(response => {
                this.progress += 100 / this.count
              })
          }
          this.form.onSuccess(response)
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    }
  }
}

</script>
